export const AimiMixin = {
  data() {
    return {
      token: '',
      urlParams: '',
      timer: '',
    }
  },
  mounted() {
    this.getToken()
  },
  computed: {
    contentByAI() {
      return this.$store.state.common.contentByAI
    }
  },
  watch: {
    contentByAI(val) {
      if (this.formData && this.formData.hasOwnProperty(val.field)) {
        this.formData[val.field] = val.content
      }
    }
  },
  methods: {
    getToken() {
      // 从url中获取token
      let url = window.location.href;
      let querys = url.substring(url.indexOf("?") + 1).split("&");
      let result = [];
      for (let i = 0; i < querys.length; i++) {
        let temp = querys[i].split("=");
        if (temp.length < 2) {
          result[temp[0]] = ""
        } else {
          result[temp[0]] = decodeURIComponent(temp[1])
        }
      }
      this.urlParams = result
      if (result["token"]) {
        this.token = result["token"]
      }

      // 从本地存储中获取token
      if (localStorage.getItem('token')) {
        this.token = localStorage.getItem('token')
      }

      return this.token
    },
    dateFormatterMinute(row, column, cellValue, index) {
      return cellValue ? this.millis2String(cellValue, '{y}-{m}-{d} {h}:{i}') : ''
    },
    millis2String(time, cFormat) {
      if (arguments.length === 0 || !time) {
        return null
      }
      const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if ((typeof time === 'string')) {
          if ((/^[0-9]+$/.test(time))) {
            // support "1548221490638"
            time = parseInt(time)
          } else {
            // support safari
            // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
            time = time.replace(new RegExp(/-/gm), '/')
          }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
          time = time * 1000
        }
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
          return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
      })
      return time_str
    },

    startIntervalSaveFormData() {
      let currentPath = this.$route.path
      console.log('进入页面获取localStorage', localStorage.getItem(currentPath))
      if (localStorage.getItem(currentPath) && localStorage.getItem(currentPath) !== 'empty') {
        this.formData = JSON.parse(localStorage.getItem(currentPath))
      } else {
        localStorage.setItem(currentPath, '')
      }
      this.timer = setInterval(() => {
        if (localStorage.getItem(currentPath) !== 'empty') {
          localStorage.setItem(currentPath, JSON.stringify(this.formData))
          console.log('定时保存localStorage', localStorage.getItem(currentPath))
        }
      }, 2000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.timer)
        this.timer = null
      })
    },
    stopIntervalSaveFormData() {
      let currentPath = this.$route.path
      clearInterval(this.timer)
      this.timer = null
      localStorage.setItem(currentPath, 'empty')
      console.log('empty后获取localStorage', localStorage.getItem(currentPath))
    },
    showAIPopup(pojo, field) {
      //个案工作的AI提问
      if (pojo === 'casework' || pojo === 'caseworkEstimate') {
        let question
        switch (pojo) {
          case 'casework':
            switch (field) {
              case 'serviceObjectDemand':
                question = '\n\n请帮我分析整理一下该服务对象可能遇到的困境和需要，最多500字。'
            }
            break;
          case 'caseworkEstimate':
            switch (field) {
              case 'basicInfo':
                question = '\n\n请帮我分析整理一下该服务对象个人的生理、心理及社会等方面的资料，最多500字。'
                break;
              case 'socialEnvironmentInfo':
                question = '\n\n请帮我分析整理一下该服务对象社会环境的微观、中观、宏观系统等资料，最多500字。'
                break;
              case 'resourcesInfo':
                question = '\n\n请帮我分析整理一下以资源为导向，识别服务对象及其所处环境中的资源、优势与障碍，最多500字。'
                break;
            }
            break
        }
        if (!this.formData.serviceObjectId) {
          this.$toast.fail('请先选择服务对象')
          return
        }
        this.$store.dispatch("server", {
          type: "get",
          url: '/socialworker/admin/serviceObject/' + this.formData.serviceObjectId,
          token: this.token,
        }).then((response) => {
          if (response.data.status === 200) {
            let serviceObject = response.data.data
            let serviceObjectInfo = `作为社工我正在进行个案工作，服务对象的信息如下
  姓名：${serviceObject.realname}
  性别：${serviceObject.gender === 1 ? '男' : (serviceObject.gender === 1 ? '女' : '')}
  年龄：${this.calculateAge_mixin(serviceObject.birthday)}
  文化程度：${serviceObject.educationLevel}
  人员类型：${this.getPersonType_mixin(serviceObject.personTypeList)}
  婚姻状况：${this.getMarriage_mixin(serviceObject.marriage)}
  经济来源：${serviceObject.economicSources}
  居住条件：${serviceObject.livingConditions}
  身体情况：${serviceObject.physicalCondition}
  情况说明：${serviceObject.situationExplain}
  房屋情况：${serviceObject.housingConditions}
  疾病信息：${serviceObject.diseaseInfo}
  社会救助情况：${serviceObject.socialAssistanceSituation}`
            question = serviceObjectInfo + question
            console.log(question)
            this.$store.commit("SHOW_AI_POPUP", {
              state: true,
              pojo: pojo,
              field: field,
              question: question,
            });
          } else {
            this.$toast.fail(response.data.msg)
          }
        })
      }
      //小组工作计划书的AI提问
      if (pojo === 'groupWorkPlan') {
        if (!this.formData.workerGroupName) {
          this.$toast.fail('请先输入小组名称')
          return
        }
        if (!this.formData.nature) {
          this.$toast.fail('请先选择小组性质')
          return
        }
        if (this.formData.objectList.length === 0) {
          this.$toast.fail('请先选择服务对象')
          return
        }
        //根据用户ID集查询年龄范围
        this.$store.dispatch("server", {
          type: "get",
          url: '/socialworker/admin/serviceObject/ageRangeByUserId',
          token: this.token,
          data: {
            userIds: this.formData.objectList.join(',')
          }
        }).then((response) => {
          if (response.data.status === 200) {
            let ageRange = response.data.data
            let question = `作为社工我正在进行小组工作计划书的编写，小组名称为”${this.formData.workerGroupName}“，小组性质为”${this.formData.nature}“，服务对象年龄段为”${ageRange}岁“，`
            switch (pojo) {
              case 'groupWorkPlan':
                switch (field) {
                  case 'problemSolution':
                    question = question + `请根据以上信息，帮我生成此次计划中”预计困难及解决办法“的相关内容，最多500字。`
                    break;
                  case 'activityBackgroundOne':
                    question = question + `请根据以上信息，帮我生成此次计划中”需求调查“的相关内容，最多500字。`
                    break;
                  case 'activityBackgroundTwo':
                    question = question + `请根据以上信息，帮我生成此次计划中”问题分析“的相关内容，最多500字。`
                    break;
                  case 'activityBackgroundThree':
                    question = question + `请根据以上信息，帮我生成此次计划中”政策依据“的相关内容，最多500字。`
                    break;
                  case 'activityBackgroundFour':
                    question = question + `请根据以上信息，帮我生成此次计划中”服务方向“的相关内容，最多500字。`
                    break;
                }
                break;
            }
            console.log(question)
            this.$store.commit("SHOW_AI_POPUP", {
              state: true,
              pojo: pojo,
              field: field,
              question: question,
            });
          } else {
            this.$toast.fail(response.data.msg)
          }
        })
      }
      //小组工作单元计划书的AI提问
      if (pojo === 'groupWorkItemPlan') {
        let question
        switch (field) {
          case 'problemSolution':
            question = `作为社工我正在进行小组工作单元计划书的编写，本单元节主题为“${this.formData.subject}“，目标为“${this.formData.activityTarget}“，请根据以上信息，帮我生成此次单元计划书中”预计困难及解决办法“的相关内容，最多500字。`
            break;
        }
        console.log(question)
        this.$store.commit("SHOW_AI_POPUP", {
          state: true,
          pojo: pojo,
          field: field,
          question: question,
        });
      }
    },
    /**
     * 获取婚姻状况
     * @param marriage
     * @returns {string}
     */
    getMarriage_mixin(marriage) {
      switch (marriage) {
        case 1:
          return '未婚'
        case 2:
          return '已婚'
        case 3:
          return '丧偶'
        case 4:
          return '离婚'
      }
    },
    /**
     * 获取人员类型
     */
    getPersonType_mixin(personTypeList) {
      let list = []
      for (let i = 0; i < personTypeList.length; i++) {
        switch (Number(personTypeList[i])) {
          case 1:
            list.push('低保户')
            break;
          case 2:
            list.push('贫困家庭')
            break;
          case 3:
            list.push('五保户')
            break;
          case 4:
            list.push('大病户')
            break;
          case 5:
            list.push('残疾户')
            break;
          case 6:
            list.push('独居老人')
            break;
          case 7:
            list.push('其他')
            break;
        }
      }
      return list.join('、')
    },
    /**
     * 根据生日计算年龄
     * @param timestamp
     * @returns {number}
     */
    calculateAge_mixin(timestamp) {
      // 将时间戳从毫秒转换为秒
      const birthDate = new Date(timestamp);
      // 获取当前日期
      const currentDate = new Date();
      // 计算年龄
      let age = currentDate.getFullYear() - birthDate.getFullYear();
      // 检查今年生日是否过了，如果没有过，年龄减一
      const hasBirthdayPassed =
        currentDate.getMonth() > birthDate.getMonth() ||
        (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() >= birthDate.getDate());
      if (!hasBirthdayPassed) {
        age -= 1;
      }
      return age;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AimiMixin.js